import { render } from "./CommunicationTemplate.vue?vue&type=template&id=40122c50"
import script from "./CommunicationTemplate.vue?vue&type=script&lang=js"
export * from "./CommunicationTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__